import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";

import * as fb from "../../../../../../firebase/firebasejs";
import { FOLIO_RESERVADO_MARCADOR } from "./folioMatrixLogic";

export default function ReserveFolioModal({
  eventoIndex,
  numero,
  estaReservado,
  onClose,
  onCambioAplicado,
}) {
  const [procesando, setProcesando] = useState(false);
  const [error, setError] = useState(null);

  const folioRef = fb.db.ref(
    `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.folios}num_${numero}`
  );

  function reservar() {
    setProcesando(true);
    setError(null);
    // Se vuelve a leer justo antes de escribir para no reservar por error un
    // folio que un atleta acaba de reclamar de verdad entre que se cargó la
    // matriz y que el admin hizo clic.
    folioRef
      .once("value")
      .then((snap) => {
        const actual = snap.val();
        if (actual && actual.atleta) {
          throw new Error("Este folio ya fue asignado, no se puede reservar.");
        }
        return folioRef.set({ atleta: FOLIO_RESERVADO_MARCADOR });
      })
      .then(() => {
        setProcesando(false);
        onCambioAplicado();
      })
      .catch((err) => {
        setProcesando(false);
        setError(err.message || "No se pudo reservar el folio");
      });
  }

  function quitarReserva() {
    setProcesando(true);
    setError(null);
    folioRef
      .remove()
      .then(() => {
        setProcesando(false);
        onCambioAplicado();
      })
      .catch((err) => {
        setProcesando(false);
        setError(err.message || "No se pudo quitar la reserva del folio");
      });
  }

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Folio {numero}</DialogTitle>
      <DialogContent>
        {estaReservado ? (
          <Typography>
            Este folio está reservado/bloqueado por un administrador — el sistema no se lo
            asignará a nadie de forma automática. Puedes quitar la reserva para que vuelva a
            estar disponible.
          </Typography>
        ) : (
          <Typography>
            Este folio todavía no tiene dueño. Puedes reservarlo/bloquearlo para que el sistema
            no se lo asigne a nadie hasta que un administrador lo asigne explícitamente a un
            inscrito.
          </Typography>
        )}
        {error && (
          <Typography color="error" style={{ marginTop: 12 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={procesando}>
          Cerrar
        </Button>
        {estaReservado ? (
          <Button
            onClick={quitarReserva}
            color="primary"
            variant="contained"
            disabled={procesando}
            startIcon={procesando ? <CircularProgress size={16} /> : null}
          >
            Quitar reserva
          </Button>
        ) : (
          <Button
            onClick={reservar}
            color="primary"
            variant="contained"
            disabled={procesando}
            startIcon={procesando ? <CircularProgress size={16} /> : null}
          >
            Reservar/bloquear
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

ReserveFolioModal.propTypes = {
  eventoIndex: PropTypes.string.isRequired,
  numero: PropTypes.number.isRequired,
  estaReservado: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCambioAplicado: PropTypes.func.isRequired,
};
